/*!
 *  (c)(r) 2008-2025 IT-Service Robert Frunzke
 */

import { jQuery } from '../other/jquery-hooked.js';

/**
 * ui widget mjResponsiveMenu
 *
 * - element is block level element (nav,div,...),
 * - must contain one <ul> element with actual navigation elements
 * example:
 *  <div id="nav1">
 *   <label>some label (stays visible)</label>
 *   <ul>
 * 		<li>...</li>
 * 		<li><a ..></a></li>
 * 	 </ul>
 *  </div>
 *
 * example:
 * 		$('#nav1').mjResponsiveMenu(options)
 * options:
 * 		closingTime		timeout after mouseleave ..
 */

(function($) {

	var defaults = {
		autoCloseMenu: true,
		closingTime: 1000,
		buttonText: 'MORE',
	};

	var methods = {
		init: function( options ) {
			// this = jquery object (liste), auf dem .mjResponsiveMenu() aufgerufen wurde

			return this.each( function() {
				// this = einzelnes DOM element aus der jquery object liste
				var self = $(this);
				self.addClass('mj-responsive-menu');

				// opts = merged defaults + options ...
				var opts = Object.assign( {}, defaults, options );

				// create initial state
				var state = {
					numOfItems: 0,
					breakWidths: [],
				};
				self.data('mj-responsiveMenuState',state);

				var $vlinks = self.find('>ul').first().addClass('mj-responsive-menu__list');

				var $remainder = $vlinks.siblings().remove();
				if( $remainder.length ) {
					$('<div class="mj-responsive-menu__remainder"></div>')
						.append($remainder)
						.appendTo(self);
					$remainder.on('mjslayoutchanged.mjResponsiveMenu',function(e) {
						state.update();
					});
				}

				var buttonText = options.buttonText;
				$vlinks.after('<div class="mj-responsive-menu__wrap"><button class="mj-responsive-menu__button">'+buttonText+'</button><ul class="mj-responsive-menu__hidden-links hidden"></ul></div>');
				var $btn = $('.mj-responsive-menu__button',this);
				var $hlinks = $('.mj-responsive-menu__hidden-links',this);


				var totalSpace = 0;
				$vlinks.children().outerWidth(function(i, w) {
					totalSpace += w;
					state.numOfItems ++;
					state.breakWidths.push(totalSpace);
				});

				state.update = function _mjResponsiveMenu_update() {
					// Get instant state
					var availableSpace = $vlinks.width() - 10;
					var numOfVisibleItems = $vlinks.children().length;
					var requiredSpace = state.breakWidths[numOfVisibleItems - 1];
					var postUpdate = false;

					if( requiredSpace > availableSpace ) {
						// There is not enough space
						$vlinks.children().last().prependTo($hlinks);
						numOfVisibleItems --;
						postUpdate = true;
					} else if( availableSpace > state.breakWidths[numOfVisibleItems] ) {
						// There is more than enough space
						$hlinks.children().first().appendTo($vlinks);
						numOfVisibleItems ++;
						postUpdate = true;
					}

					// Update the button accordingly
					$btn.attr('count', state.numOfItems-numOfVisibleItems );
					if( numOfVisibleItems===state.numOfItems ) {
						$btn.addClass('hidden');
					} else {
						$btn.removeClass('hidden');
						$hlinks.css('right',numOfVisibleItems===0?'auto':'0px');
					}

					if( postUpdate ) state.update();
				};

				var autoCloseTimer;

				$btn.on( 'click.mjResponsiveMenu', function() {
					$hlinks.toggleClass('hidden');
					clearTimeout(autoCloseTimer);
				} );

				if( opts.autoCloseMenu ) {
					$hlinks
						.on( 'mouseleave.mjResponsiveMenu', function() {
							// Mouse has left, start the timer
							autoCloseTimer = setTimeout( function() {
								$hlinks.addClass('hidden');
							}, opts.closingTime );
						} )
						.on( 'mouseenter.mjResponsiveMenu', function() {
							// Mouse is back, cancel the timer
							clearTimeout(autoCloseTimer);
						} );
				}

				state.update();
			} );

		},

		update: function() {
			var state = $(this).data('mj-responsiveMenuState');
			if( state && state.update ) state.update();
		},

		destroy: function() {
			return this.each( function() {
				var self = $(this);
				self.removeClass('mj-responsive-menu')
					.find('>.mj-responsive-menu__wrap').remove();
				var $list = self.find('>ul').first();
				$list.removeClass('mj-responsive-menu__list');
				var $remainder = $list.siblings();
				if( $remainder.length ) {
					$remainder.contents().off('.mjResponsiveMenu').unwrap();
				}
			} );
		},
	};

	$.fn.mjResponsiveMenu = function( method ) {
		if( methods[method] ) {
			return methods[method].apply(this,Array.prototype.slice.call(arguments,1));
		} else if( typeof method === 'object' || !method ) {
			return methods.init.apply(this,arguments);
		}
		$.error( 'Method '+method+' does not exist on jQuery.mjResponsiveMenu' );
	};

})(jQuery);
